import './Switch.css'

export function Switch({ checked, onChange, children, style, ...rest }) {
  return (
    <label className="u-switch" style={style}>
      <input type="checkbox" checked={checked} onChange={onChange} {...rest} />
      <span className="u-track" />
      {children && <span>{children}</span>}
    </label>
  )
}

export default Switch
